/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Border_Style_Outline_ShadowInputs */



/**
* | output |
* | --- |
* | "Outline + Shadow" |
*
* @param {Video_Export_Border_Style_Outline_ShadowInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_border_style_outline_shadow = /** @type {((inputs?: Video_Export_Border_Style_Outline_ShadowInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Border_Style_Outline_ShadowInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Contour + ombre")
	if (locale === "de") return /** @type {LocalizedString} */ ("Kontur + Schatten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Contorno + Ombra")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Контур + Тень")
	if (locale === "es") return /** @type {LocalizedString} */ ("Contorno + Sombra")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("轮廓 + 阴影")
	if (locale === "ja") return /** @type {LocalizedString} */ ("アウトライン + 影")
	if (locale === "hi") return /** @type {LocalizedString} */ ("रूपरेखा + छाया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Contorno + Sombra")
	return /** @type {LocalizedString} */ ("Outline + Shadow")
});